import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    SharedPositioningType,
} from 'app/Apps/OrderManagement/Orders/orders.types'

import requests from 'app/requests/Order/Order.requests'

const useGetSharePositioning = (orderNumber) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useRequest<SharedPositioningType[]>({
        key: RequestKeys.getSharePositioning,
        params: {
            orderNumber,
        },
        requestFunc: RequestFn.getEntity(requests.getSharedPositioningOrders),
    })

    return {
        sharedPositioning: data,
        isDataReady,
        isFetching,
        isError,
        error,
    }
}

export default useGetSharePositioning
